const NoPage = () => {
    return (
    <div className="flex mx-auto justify-center">
      <div className="py-16 text-center">
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <p><a href="/" className="text-blue-700">Return to the homepage</a></p>
      </div>
    </div>
    )
  };
  
  export default NoPage;